import {
  Box, Col, media, PrimaryButton,
  Row,
  Checkbox, TableHead, TableHeader, TableRow,
} from 'ia-react-core';
import styled from 'styled-components';

export const StyledRightCol = styled(Col)`
padding-left: 18px;
padding-right: 18px;
text-align : center;
display: flex;

  ${media.sm`
    text-align: right;
    display: block;
    flex: 1;
    top: 0px;
  `};
`;

export const StyledLeftCol = styled(Col)`
  text-align : center;
  ${media.sm`
    text-align: left;
  `};
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  height: 50px;
  flex: 1;
  font-weight: bold;

  ${media.sm`
    flex: 0;
  `};
`;

export const StyledRow = styled(Row)`
  margin-bottom: 36px;
  ${media.sm`
    margin-bottom: 0;
  `};
`;

export const StyledBox = styled(Box)`
  background-color: transparent;
  padding: 0px;
`;

export const StyledPage = styled.div`
  max-width:${({ theme }) => theme.layout.maxContentWidth};
`;

/* Styles des pages de messages reçus et envoyés */
export const StyledTableHead = styled(TableHead)`
padding-bottom: 0px;
`;

export const StyledTableRow = styled(TableRow)`
border-bottom: 1px solid #1b1b1b;
`;

export const StyledMessagesHeaderWithoutText = styled(TableHeader)`
text-align: center !important;
max-width: 30px;
padding-bottom:0px;
text-align: center;
vertical-align: middle;
`;

export const StyledTableCellLeft = styled(TableHeader)`
text-align: left !important;
max-width: 410px;
`;

export const StyledTableCellRight = styled(TableHeader)`
text-align: right !important;
max-width: 200px;
padding-right: 16px;
`;

export const StyledCheckBox = styled(Checkbox)`
margin:auto !important;
display:flex;
`;
